import { queryOptions } from "@tanstack/react-query";
import { getFavoriteArticles, getFavoriteWorkshops, getUserProfileData, getSubscriptionCourse } from "./api";
import type { CourseKey } from "./api.types";

export const getFavoriteArticlesOptions = queryOptions({
	queryKey: ["favorite-articles"],
	queryFn: () => getFavoriteArticles(),
});

export const getFavoriteWorkshopsOptions = queryOptions({
	queryKey: ["favorite-workshops"],
	queryFn: () => getFavoriteWorkshops(),
});

export const getProfileOptions = queryOptions({
	queryKey: ["profile"],
	queryFn: () => getUserProfileData(),
	staleTime: 1000 * 60 * 60 * 24, // 24 hours
	// przy okazji zrefactorowałbym dziwną logikę miedzy WorkshopContentAuth oraz WorkshopStudy !!! (o co tam chodzi?)
});

// Return type is complex and inferred correctly by TypeScript
export const getSubscriptionCourseOptions = (courseKey: CourseKey): ReturnType<typeof queryOptions> =>
	queryOptions({
		queryKey: ["subscriptionCourse", courseKey],
		queryFn: () => getSubscriptionCourse(courseKey),
	}) as ReturnType<typeof queryOptions>;
